module.exports = "/_next/static/images/0037c9eb8570b5364d9fad2c419af7a6-press-hero-desktop.jpg.webp";